export default __webpack_public_path__ + "static/media/noFiles.961a9b19.svg";